// extracted by mini-css-extract-plugin
module.exports = {"errorCard":"error_errorCard__YjSyV","buttonContainer":"error_buttonContainer__QkXf7"};